<div class="row pt-4 px-4" *ngIf="show">
    <div class='col-12'>
        No data available for the selected filters.
    </div>
</div>